import { render, staticRenderFns } from "./OracleZjjhbForm.vue?vue&type=template&id=e975c814&"
import script from "./OracleZjjhbForm.vue?vue&type=script&lang=js&"
export * from "./OracleZjjhbForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports